import { render, staticRenderFns } from "./ExcursionAdminModal.vue?vue&type=template&id=0361971f&scoped=true"
import script from "./ExcursionAdminModal.vue?vue&type=script&lang=ts"
export * from "./ExcursionAdminModal.vue?vue&type=script&lang=ts"
import style0 from "./ExcursionAdminModal.vue?vue&type=style&index=0&id=0361971f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361971f",
  null
  
)

export default component.exports